export const round = (number, places = 2) => {
  if (!isFinite(number)) return number
  return +(Math.round(number + 'e+' + places) + 'e-' + places)
}

export const parseAndRound = (number, places) => {
  return round(parseFloat(number), places)
}
